import { useEffect, useRef } from "react";
import { Map, useMap } from "@vis.gl/react-google-maps";

const DEFAULT_CENTER = { lat: 47.0379, lng: -122.9007 };
const DEFAULT_ZOOM = 11;

function DirectionsRenderer({ directions, selectedRouteIndex }) {
  const map = useMap();
  const rendererRef = useRef(null);

  useEffect(() => {
    if (!map || !window.google) {
      return;
    }

    if (!rendererRef.current) {
      rendererRef.current = new window.google.maps.DirectionsRenderer({
        map,
        suppressMarkers: false,
        preserveViewport: false,
      });
    }

    if (directions) {
      rendererRef.current.setDirections(directions);
      rendererRef.current.setRouteIndex(selectedRouteIndex || 0);
    }

    return () => {
      rendererRef.current?.setMap(null);
      rendererRef.current = null;
    };
  }, [map, directions, selectedRouteIndex]);

  return null;
}

export default function TripMap({ directions, selectedRouteIndex }) {
  return (
    <Map
      defaultCenter={DEFAULT_CENTER}
      defaultZoom={DEFAULT_ZOOM}
      gestureHandling="greedy"
    >
      <DirectionsRenderer
        directions={directions}
        selectedRouteIndex={selectedRouteIndex}
      />
    </Map>
  );
}
